import { IconButton, Tooltip } from "@mui/material";
import { Build } from "@mui/icons-material";
import Messages from "../../../localization/Messages";
import { useState } from "react";
import { useIntl } from "react-intl";
import RpisDialog from "../../RpisDialog/RpisDialog";
import ShipRemarkDialog from "./ShipRemarkDialog";
import { useSidebarOwner } from "../../../contexts/SidebarOwnerContext";
import { IShipDispatcher } from "../../../models/shipDispatcher";
import "./EditShipTechnicalRemark.css";

export type EditShipTechnicalRemarkProps = {
    onSubmit?: () => Promise<void>;
    disabled?: boolean;
};

export function EditShipTechnicalRemark({
    onSubmit = async () => {},
    disabled = false,
}: EditShipTechnicalRemarkProps) {
    const [ship] = useSidebarOwner<IShipDispatcher>();
    const remark = ship?.remarksTechnical;
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const buttonTitleSuffix = remark ? `: ${remark}` : "";

    const onOpen = () => {
        if (!disabled) setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Tooltip
                key={remark}
                title={`${intl.formatMessage(Messages.editShipTechnicalRemark)}${buttonTitleSuffix}`}
            >
                <IconButton
                    onClick={onOpen}
                    className="ship-technical-remark-icon"
                    aria-label={intl.formatMessage(Messages.editShipTechnicalRemark)}
                    disabled={disabled}
                >
                    <Build />
                </IconButton>
            </Tooltip>
            <RpisDialog
                fullWidth
                size="sm"
                dialogOpen={open}
                title={intl.formatMessage(Messages.editShipTechnicalRemark)}
                onClose={onClose}
                content={
                    <ShipRemarkDialog
                        onClose={onClose}
                        onSubmit={onSubmit}
                        field="remarksTechnical"
                    />
                }
            />
        </>
    );
}

export default EditShipTechnicalRemark;
